"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_SHADOW = exports.INNER_SHADOW = exports.FLAT_SHADOW = exports.DROP_SHADOW = void 0;
var DROP_SHADOW = "0 2px 10px 0 rgba(0, 0, 0, 0.1)";
exports.DROP_SHADOW = DROP_SHADOW;
var INNER_SHADOW = "1px 1px 2px 0 rgba(0, 0, 0, 0.1) inset";
exports.INNER_SHADOW = INNER_SHADOW;
var FLAT_SHADOW = "0 1px 1px 0 rgba(0, 0, 0, 0.05)";
/** Shadow to drop under text to improve legibility when over images */
exports.FLAT_SHADOW = FLAT_SHADOW;
var TEXT_SHADOW = "0 0 15px rgba(0, 0, 0, 0.25)";
exports.TEXT_SHADOW = TEXT_SHADOW;
//# sourceMappingURL=shadow.js.map